import { Form, Formik } from "formik";
import * as yup from "yup";
import { FormikInput } from "@/components/common/form/FormikInput.tsx";
import { Button } from "@/components/base/Button.tsx";
import { CreateTenantDto, PatchTenantDto, Tenant } from "@/models";

type CreateEditTenantFormProps = {
  onSubmit: (values: CreateTenantDto | PatchTenantDto) => Promise<void>;
  initialData?: Tenant;
  onCancel?: () => void;
  isEditable?: boolean;
};

const validationSchema = yup.object({
  name: yup.string().required("Name is required"),
});

export const CreateEditTenantForm = ({
  initialData,
  onCancel,
  onSubmit,
  isEditable,
}: CreateEditTenantFormProps) => {
  const handleCancel = () => {
    console.log("cancelling");
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <Formik
      initialValues={{
        name: initialData?.name ?? "",
        joinCode: initialData?.joinCode ?? "",
      }}
      validateOnMount={true}
      enableReinitialize={true}
      validationSchema={validationSchema}
      onSubmit={async (values, { setSubmitting }) => {
        setSubmitting(true);
        let submitData: CreateTenantDto | PatchTenantDto = {
          name: values.name,
          joinCode: values.joinCode,
        } as CreateTenantDto;
        if (initialData?.id) {
          submitData = {
            id: initialData.id,
            ...submitData,
          } as PatchTenantDto;
        }

        onSubmit(submitData).finally(() => setSubmitting(false));
        return;
      }}
    >
      {({ values, handleSubmit }) => (
        <Form
          className="flex flex-col sm:grid sm:grid-cols-1 gap-4 m-auto w-64 sm:w-auto max-w-screen-md"
          onSubmit={handleSubmit}
        >
          <div className="flex md:col-span-1 flex-col gap-2 border p-2">
            <h3 className="text-lg">Tenant Information</h3>

            <FormikInput
              name="name"
              type="text"
              id="name"
              label="Tenant Name"
              disabled={!isEditable}
            />

            {initialData && (
              <FormikInput
                name="joinCode"
                type="text"
                id="joinCode"
                label="Join Code"
                disabled={!isEditable}
              />
            )}
          </div>

          {isEditable && (
            <div className="flex md:col-span-3 flex-row gap-4 justify-end">
              <Button
                variant={"secondary"}
                onClick={handleCancel}
                type="button"
              >
                Cancel
              </Button>
              <Button type="submit" disabled={values.name === ""}>
                Save
              </Button>
            </div>
          )}
        </Form>
      )}
    </Formik>
  );
};
